module.exports = __webpack_public_path__ + "img/1.47ad68af.png";